import JSONModel from "sap/ui/model/json/JSONModel";
import BindingMode from "sap/ui/model/BindingMode";
import Device from "sap/ui/Device";
import UI5Date from "sap/ui/core/date/UI5Date";

export default {
  createDeviceModel: () => {
    const oModel = new JSONModel(Device);
    oModel.setDefaultBindingMode(BindingMode.OneWay);
    return oModel;
  },
};

export interface ApiErrorDto {
  phrase: string;
  status: number;
  error: string;
  family: "INFORMATIONAL" | "SUCCESSFUL" | "REDIRECTION" | "CLIENT_ERROR" | "SERVER_ERROR" | "OTHER";
}

export interface Customer {
  Id: number;
  Lfd: number;
  Name: string;
  Ansprechpartner: string;
  PLZ: number;
  Ort: string;
  Entfernung: number;
}

export interface User {
  Username: string;
}

export interface Besuchsbericht {
  anlagedatum?: string | Date | UI5Date;
  massnahmen?: string;
  ersteller?: string;
  beschreibung?: string;
  besuchAm?: string | Date | UI5Date;
  id?: number;
  kundenId?: number;
  kundenLfd?: number;
  artId?: number;
  betreff?: string;
  besuchBis?: string | Date | UI5Date;
  wiedervorlagedatum?: string | Date | UI5Date;
  haus?: number;
  teilnehmer?: BesuchsberichtTeilnehmer[];
  kundenName: string;
  kundenVorname: string;
  kundenFirma: string;
  artDescription: string;
  canWrite: boolean;
  istErledigt: boolean;
}

export interface BesuchsberichtTeilnehmer {
  key: string;
  name: string;
}

export interface KundeRemarks {
  anmerkung1: string;
  anmerkung2: string;
  vid: number;
}

export interface Artikel {
  id: number;
  bereich: number;
  imageUrl: string;
  warengruppe: number;
  artikelgruppe: number;
  artikelnummer: number;
  art: string;
  kurzbezeichnung: string;
  bezeichnung1: string;
  bezeichnung2: string;
  ean: string;
  listenEK: number;
  mengeneinheitText: string;
  preiseinheit: number;
  basisVKExclMwst: number;
  basisVKInklMwst: number;
  beschreibungLang: string;
  artikeldrucktext: string;
  eigenschaften: Artikelkategorisierung[];
  berechneterPreis: Preis;
}

export interface Artikelkategorisierung {
  artikelId: number;
  eigenschaftId: number;
  ebene: number;
  categorieId: number;
  categorieName: string;
  categorieBezeichnung: string;
  categorieAktiv: boolean;
  name: string;
  bezeichnung: string;
  aktiv: boolean;
  einheitText: string;
  typ: string;
  defaultValue: string;
  displayWert: string;
  sortierung: number;
}

export interface ArticleListArticle extends Artikel {
  preis: number;
  preisMeasure: string;
}

export interface Preis {
  gesamtPreisBrutto: number;
  gesamtPreisNetto: number;
}

export interface ZubehoerArtikel {
  artikelId: number;
  fuehrungsartikelId: number;
  kosten: number;
  bezeichnung1: string;
  bezeichnung2: string;
  ean: string;
}

export interface Belegposition {
  art: string;
  artikelId: number;
  einzelpreis: number;
  summe: number;
  deckungsbeitrag: number;
  artikelbezeichnung1: string;
  artikelbezeichnung2: string;
  ean: string;
  einkaufspreis: number;
  haus: number;
  menge: number;
  sollVk: number;
  kommissionsnummer: string;
  lieferbedingung: string;
  druckstatus: string;
  mwst: number;
  belegnummer: number;
  nummer: number;
  preiseinheit: number;
  rabatt: number;
  spanne: number;
  artikelnummer: number;
  warengruppe: number;
  bereich: number;
  artikelgruppe: number;
  einheit: string;
}

export class FileSettings {
  ALLOWED_DOCUMENT_EXTENSIONS: Array<string>;
  MAX_DOC_SIZE: number;
  user_allowed_to_delete: boolean;
  enabled: boolean;
}

export interface Finanzauskunft {
  label1: string;
  wert1: number;
  label2: string;
  wert2: number;
  label3: string;
  wert3: number;
  label4: string;
  wert4: number;
  label5: string;
  wert5: number;
  label6: string;
  wert6: number;
  label7: string;
  wert7: number;
  label8: string;
  wert8: number;
  label9: string;
  wert9: number;
  label10: string;
  wert10: number;
  label11: string;
  wert11: number;
  label12: string;
  wert12: number;
  label13: string;
  wert13: number;
  kreditlimit: number;
  kreditversicherung: number;
  betreuer: string;
  betreuerName: string;
  betreuerTelefon: string;
  betreuerEmail: string;
  zahlungsbedingung: string;
  zahlungsbedingungText: string;
  aenderungsdatum: string;
  freiesLimit: number;
  freiesLimitProzent: number;
  freiesLimitLabel: string;
  finanzauskunftGesamt: number;
  offenePostenGesamt: number;
  laufendePeriodeUmsatz: number;
  laufendePeriodeDeckungsbeitrag: number;
  laufendePeriodeSpanne: number;
  laufendesJahrUmsatz: number;
  laufendesJahrDeckungsbeitrag: number;
  laufendesJahrSpanne: number;
  vorherigesJahrUmsatz: number;
  vorherigesJahrDeckungsbeitrag: number;
  vorherigesJahrSpanne: number;
  letzte12MonateUmsatz: number;
  letzte12MonateDeckungsbeitrag: number;
  letzte12MonateSpanne: number;
}

export interface Kontakt {
  kundeId: number;
  kundeLfd: number;
  abteilung: null;
  email: null;
  telefonMobil: null;
  telefonFestnetz: string;
  id: number;
  vorname: string;
  nachname: string;
  anrede: string;
  titel: null;
  vid: number;
  aktiv: string;
}

export interface GeburtstagsKontakt extends Kontakt {
  alter: number;
  tageBisGeburtstag: number;
  naechsterGeburtstag: string;
  firmenName: string;
  betreuerTechNo: string;
  betreuerName: string;
  hausName: string;
}

export interface SendMessageResponse {
  threadId: string;
  runId: string;
}

export interface MessageResponse {
  id: string;
  createdAt: string;
  role: string;
  text: string;
}

export interface RunStatusResponse {
  status: string;
  createdAt: string;
  completedAt: string;
  functionCalls: RunFunctionCall[];
}

export interface RunFunctionCall {
  toolCallId: string;
  functionName: string;
  arguments: string;
}

export interface DisplayMessage {
  id?: string;
  createdAt?: string;
  imageUrl?: string;
  sender: string;
  text: string;
  visible?: boolean;
  isLoading?: boolean;
}

export interface TokenResponse {
  token: string;
  region: string;
  scope: string;
}

export interface CreateAufgabeDto {
  verantwortlich: string;
  faelligkeitsdatum: string;
  betreff: string;
  beschreibung?: string;
}

export interface ToolCallFunctionResult {
  toolCallId: string;
  result: string;
}

export interface SubmitToolCallRequest {
  functionResults: ToolCallFunctionResult[];
}

export interface UserConfiguration {
  experimentalFeaturesEnabled: boolean;
}

export interface CENTRY {
  CENTRY_CODE: string;
  CENTRY_DESC: string;
  CENTRY_ORDER: number;
}
